module.exports = __webpack_public_path__ + "img/credit.e6165015.svg";